import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useLocation, useNavigate } from 'react-router-dom';
import "./GetCoupon.css";
import PaymentProvider from '../payment/PaymentProvider';
import { useTranslation } from 'react-i18next';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const serverUrl = "/api";

const CheckoutForm = ({ name, price, gameId, mail }) => {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const handlePayment = async () => {
    if (!stripe || !elements) return;

    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(serverUrl + '/create-payment-intent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: price }),
      });
      const { clientSecret } = await response.json();

      const token = localStorage.getItem('token');
      const billingDetails = token?.trim()
        ? { name: token }
        : { email: mail };

      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
          billing_details: billingDetails,
        },
      });

      if (result.error) {
        setError(`Payment failed: ${result.error.message}`);
      } else {
        const provider = new PaymentProvider();
        const data = await provider.createCoupon(token, gameId, price, mail || "");
        if (data) {
          navigate('/success', { state: data, replace: true });
        } else {
          setError("Problem creating new coupon");
        }
      }
    } catch (err) {
      console.error('Payment error:', err);
      setError('Error processing payment');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="checkout-form-pay">
      <h2>{name}</h2>
      <p className="price">{t('price')}: {price} {t('eur')}</p>
      <CardElement className="card-element" />
      <button className="payment-button" onClick={handlePayment} disabled={isLoading}>
        {isLoading ? <div className="spinner"></div> : t('buy_coupon')}
      </button>
      {error && <p className="error">{error}</p>}
      <p className="secure-info">🔒 {t('your_payment_is_secure_with_stripe')}</p>
    </div>
  );
};

const GetCoupon = () => {
  const { t } = useTranslation();
  const [gameData, setGameData] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const { state } = location;
    setGameData(state);
  }, [location]);

  if (!gameData) return <div>{t('loading')}...</div>;

  return (
    <div className="get-coupon">
      <Elements stripe={stripePromise}>
        <CheckoutForm
          name={gameData.name}
          price={gameData.price}
          gameId={gameData.gameId}
          mail={gameData.mail}
        />
      </Elements>
    </div>
  );
};

export default GetCoupon;
